import React from "react";

export const SCROLL_LOAD_THRESHOLD_PX = 24;
export const isNearScrollBottom = (
  element: HTMLElement,
  threshold = SCROLL_LOAD_THRESHOLD_PX,
) =>
  element.scrollTop + element.clientHeight >= element.scrollHeight - threshold;

export const createListboxScrollHandler = (
  onLoadMore?: () => void,
): React.UIEventHandler<HTMLUListElement> | undefined =>
  onLoadMore
    ? (event: React.UIEvent<HTMLUListElement>) => {
        if (isNearScrollBottom(event.currentTarget)) {
          onLoadMore();
        }
      }
    : undefined;

export const createScrollHandler = (
  onLoadMore?: () => void,
): React.UIEventHandler<HTMLElement> | undefined =>
  onLoadMore
    ? (event: React.UIEvent<HTMLElement>) => {
        if (isNearScrollBottom(event.currentTarget)) {
          onLoadMore();
        }
      }
    : undefined;